<template>
  <div
      class="w-100"
  >

    <!-- Überschrift ist übersetzter Label aus dem übergebenen Filter -->
    <h4 :id="'rs-'+ filter.namespace" class="label-title" >{{ _t(filter.label) }}</h4>
    <Slider
        ref="slider"
        @change="check(filter.namespace, $event)"
        @update="doRefresh($event)"
        :id="filter.id"
        :value=[getFrom(),getTo()]
        :min="getMin()"
        :max="getMax()"
        :classes="filter.class"
        :format="format"
        :merge="1000"
        :showTooltip="'drag'"
    />
  </div>

</template>
<script>
import Slider from "@vueform/slider";

export default {
  emits: ["update:value"],
  props: {
    _t: {
      type: Function
    },
    filter: {
      type: Object,
      required: true,
    },
    format: {
      type: Object,
      required: false,
    },
  },
  setup(props, context) {

    /**
     * Verarbeitet nach dem Klick des Users eine gecheckte|geuncheckte Option
     * @param {string} optionValue Wert der Option
     * @param {string} namespace Namespace des betroffenen Filters
     * @param {boolean} checked Ist die Option gecheckt?
     */
    const check = (namespace, value) => {
      context.emit("update:value", value, namespace);
    };

    const doRefresh = () => {
      console.log('')
    };
    return {
      check,
      doRefresh
    };
  },
  methods: {
    getMin: function()  {
      return this.filter.min ? parseInt(this.filter.min) : 0
    },
    getMax: function()  {
      return this.filter.max ? parseInt(this.filter.max) : 12
    },
    getFrom: function()  {
      let from = this.filter.queries && this.filter.queries.length > 1 ? this.filter.queries[0] : parseInt(this.filter.min)
      return from
    },
    getTo: function()  {
      let to = this.filter.queries && this.filter.queries.length > 1 ? this.filter.queries[1] : parseInt(this.filter.max)
      return to
    },
    reset : function () {
      this.$refs.slider.refresh(1,2)
      this.$refs.slider.reset()
    }
  },
  components: {
    "Slider": Slider,
  },
  data: () => ({})

};
</script>